/**
 * Contact Us Button Component (Feature 022)
 *
 * Button that allows service providers to request profile updates
 * by contacting support.
 */

import { Button } from '@/shared/components/ui/button';

type ContactUsButtonProps = {
  onContactClick: () => void;
};

export function ContactUsButton({ onContactClick }: ContactUsButtonProps) {
  return (
    <Button
      onClick={onContactClick}
      className="w-full bg-bquest-green hover:bg-bquest-green/90 text-white"
    >
      Contact us to request updates
    </Button>
  );
}
